import { createFileRoute } from "@tanstack/react-router";
import { GapSurchargesListPage } from "@/features/contracts/gap-surcharges-list-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/doplaty-gap/")({
	component: GapSurchargesListPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.doplaty-gap",
			location.pathname,
		);
	},
});
